import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.51172 10C9.34015 10 10.0117 9.32843 10.0117 8.5C10.0117 7.67157 9.34015 7 8.51172 7C7.68329 7 7.01172 7.67157 7.01172 8.5C7.01172 9.32843 7.68329 10 8.51172 10Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0117 8.5C17.0117 9.32843 16.3401 10 15.5117 10C14.6833 10 14.0117 9.32843 14.0117 8.5C14.0117 7.67157 14.6833 7 15.5117 7C16.3401 7 17.0117 7.67157 17.0117 8.5Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.17609 12.9819C8.9954 12.46 9.45943 12 10.0117 12H14.0117C14.564 12 15.028 12.46 14.8473 12.9819C14.4407 14.1565 13.3247 15 12.0117 15C10.6987 15 9.58277 14.1565 9.17609 12.9819Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.01172 24H15.0117C19.9823 24 24.0117 19.9706 24.0117 15V9C24.0117 4.02944 19.9823 0 15.0117 0H9.01172C4.04116 0 0.0117188 4.02944 0.0117188 9V15C0.0117188 19.9706 4.04116 24 9.01172 24ZM15.0117 2H9.01172C5.14573 2 2.01172 5.13401 2.01172 9V15C2.01172 18.866 5.14573 22 9.01172 22H13.739C14.2913 22 14.739 21.5523 14.739 21V17.7273C14.739 16.0704 16.0821 14.7273 17.739 14.7273H21.0117C21.564 14.7273 22.0117 14.2796 22.0117 13.7273V9C22.0117 5.13401 18.8777 2 15.0117 2ZM21.8243 16.6159C21.2174 19.1841 19.1959 21.2057 16.6276 21.8126C16.7002 21.5541 16.739 21.2816 16.739 21V17.7273C16.739 17.175 17.1867 16.7273 17.739 16.7273H21.0117C21.2933 16.7273 21.5659 16.6885 21.8243 16.6159Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }